import { createAsyncThunk } from "@reduxjs/toolkit";
import { SecureGet, SecurePost } from "../services/axiosCall";
import apis from "../services/Apis";
import Alert from "../components/common/alert";
import {
  retriveToken,
  getAllCategory,
  getAllReward,
  getAllActiveOrders,
} from "../services/AuthServices";

export const fetchTrainerTableData = createAsyncThunk(
  "trainer/fetchTrainerTableData",
  async (_, thunkAPI) => {
    try {
      const response = await SecureGet({ url: apis.GET_ALL_TRAINER });
      // console.log(response.data.data);
      if (response.data.success) {
        return response.data.data; // This becomes action.payload in fulfilled
      } else {
        // You can throw error to catch block
        throw new Error(response.data.message || "Failed to fetch trainers");
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const changeTrainerModalState = createAsyncThunk(
  "trainer/changeModalState",
  async ({ showModal, trainerId, actionType }, { rejectWithValue }) => {
    try {
      if (actionType === "Save Changes") {
        const response = await SecureGet({
          url: `${apis.GET_SINGLE_TRAINER_DETAILS}/${trainerId}`,
        });

        if (response.data.success) {
          const trainerData = response.data.data[0];
          // Alert("success", "Success", response.data.message);
          return {
            showModal: true,
            trainerId,
            actionType,
            formData: {
              ...trainerData,
              contact: trainerData.contact.slice(3),
              prefix: trainerData.contact.slice(0, 3),
            },
          };
        } else {
          Alert("warning", "Warning!", response.data.message);
          return rejectWithValue(response.data.message);
        }
      } else {
        return {
          showModal,
          trainerId,
          actionType,
          formData: {
            name: null,
            emailid: null,
            contact: null,
            prefix: null,
            password: null,
            confirmpassword: null,
          },
        };
      }
    } catch (error) {
      Alert("error", "Error!", error.message);
      return rejectWithValue(error.message || "Server Error");
    }
  }
);

export const createOrUpdateTrainer = createAsyncThunk(
  "admin/createOrUpdateTrainer",
  async ({ payload, isEdit }, { rejectWithValue }) => {
    try {
      const response = await SecurePost({
        url: apis.CREATE_TRAINER,
        data: payload,
      });
      // console.log(response.data);
      if (response.data.success) {
        return {
          success: true,
          message: response.data.message,
          data: response.data.data,
        };
      } else {
        return rejectWithValue({
          success: false,
          message: response.data.message,
        });
      }
    } catch (error) {
      return rejectWithValue({
        success: false,
        message: error.response?.data?.message || error.message,
      });
    }
  }
);

export const fetchStudentTableData = createAsyncThunk(
  "trainer/fetchStudentTableData",
  async (_, thunkAPI) => {
    try {
      const response = await SecureGet({ url: apis.GET_ALL_STUDENT });
      // console.log(response.data.data);
      if (response.data.success) {
        // console.log(response.data.data);

        return response.data.data; // This becomes action.payload in fulfilled
      } else {
        // You can throw error to catch block
        throw new Error(response.data.message || "Failed to fetcH students");
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const fetchSubjectTableData = createAsyncThunk(
  "trainer/fetchSubjectTableData",
  async (_, thunkAPI) => {
    try {
      const response = await SecureGet({ url: apis.GET_ALL_SUBJECTS });
      // console.log(response.data.data);
      if (response.data.success) {
        //  console.log(response.data.data);

        return response.data.data; // This becomes action.payload in fulfilled
      } else {
        // You can throw error to catch block
        throw new Error(response.data.message || "Failed to fetch subject");
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

//fetch Category
export const fetchAllCategories = createAsyncThunk(
  "admin/fetchAllCategories",
  async (_, { rejectWithValue }) => {
    try {
      const token = retriveToken();
      if (!token || token === "undefined") {
        window.location = "/";
        return rejectWithValue("No token found");
      }

      const response = await getAllCategory(token);
      return response?.data?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
//fetch Rewards
export const fetchAllRewards = createAsyncThunk(
  "admin/fetchAllRewards",
  async (_, { rejectWithValue }) => {
    try {
      const token = retriveToken();
      if (!token || token === "undefined") {
        window.location = "/";
        return rejectWithValue("No token found");
      }

      const response = await getAllReward(token);
      // console.log(response.data.data);

      return response?.data?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

//Active orders
export const fetchAllActiveOrders = createAsyncThunk(
  "admin/fetchAllActiveOrders",
  async (_, { rejectWithValue }) => {
    try {
      const token = retriveToken();
      if (!token || token === "undefined") {
        window.location = "/";
        return rejectWithValue("No token found");
      }

      const response = await getAllActiveOrders(token);
      // console.log(response.data.data);

      return response?.data?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
